import { Injectable, TransferState } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { GraphqlService } from '../graphql/graphql.service';
import { BrowserCheckService } from '@app/utils/browser-check.service';
import { AuthenticationService } from '../authentication/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private graphqlService: GraphqlService,
    private browserCheck: BrowserCheckService,
    private authenticationService: AuthenticationService,
    private transferState: TransferState,
  ) {}

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const slugParam = next.paramMap.get('slug') || '';
    const nested = next.paramMap.get('nested') || '';
    const slug = nested ? `${slugParam}/${nested}` : slugParam;

    if (!this.browserCheck.isBrowser()) {
      return of(true);
    }

    // Hydration stalling:
    return this.graphqlService.getPageProtectionStatus(slug).pipe(
      map((isProtected) => {
        const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
        const accessToken = next.queryParamMap.get('accessToken') || '';

        if (isProtected && !isLoggedIn) {
          if (
            accessToken &&
            this.authenticationService.validateToken(accessToken)
          ) {
            return true;
          }
          // Return UrlTree
          return this.router.createUrlTree(['/']);
        }

        return true;
      }),
    );
  }
}
